import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';
import { SharedModule } from './../../../../shared/shared.module';
import { SellerPercentComponent } from '../seller-percent/seller-percent.component';
import { OtherSellersPercentComponent } from '../other-sellers-percent/other-sellers-percent.component';
import { PropertyDivisionFormComponent } from '../property-division-form/property-division-form.component';




@NgModule({
  declarations: [ProgressBarComponent,SellerPercentComponent, OtherSellersPercentComponent, PropertyDivisionFormComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  providers:[DecimalPipe],
  exports: [ProgressBarComponent, SellerPercentComponent, OtherSellersPercentComponent, PropertyDivisionFormComponent]
})
export class SharedComponentsModule { }
